/**
 * Created by pandemio on 4/1/19.
 */
import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from 'reactstrap';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/
import UsersDataTable from '../datatables/users-data-table';
import Settings from '../../custom-classes/settings';

/**
 * Model that handles the clients
 */
class ModalClients extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: props.visible
        };

        this.toggle = this.toggle.bind(this);
        this.handleSelectedUser = this.handleSelectedUser.bind(this);
    }

    /**
     * Hide or shows the window
     */
    toggle() {
        this.setState({
            visible: !this.state.visible
        },()=>{
            this.props.updateParent(null);
        });
    }

    handleSelectedUser(e){
        this.props.updateParent(e);
    }

    render() {
        return (
            <div>
                <Modal isOpen={this.state.visible} toggle={this.toggle} className="modal-results">
                    <ModalHeader toggle={this.toggle}>
                        <Translate id="users-search.clients"/>
                        <br/>
                        <small>
                            <Translate id="users-search.clients-instructions"/>
                        </small>
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <UsersDataTable roleId={Settings.CLIENT_ROLE_ID} updateParent={this.handleSelectedUser}/>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.toggle} color="info">
                            <Translate id="general.close"/>
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
export default ModalClients;